<div class="container-fuid bg-white default-boxrounded">
    <div class="col-12 w-100">
        <h3 class="title col-9">
            <span translate="Dialog.DeleteUserTitle"></span>
        </h3>
    </div>

    <div class="p-4 pt-0">
        <div class="lh-base" [translateParams]="{fullUserName:userName}" translate="Dialog.DeleteUserInformation"></div>
        <ng-container *ngIf="hasRequests">
            <div class="lh-base mt-3 pb-2" [translateParams]="{fullUserName: userName, requestCount: requests.length}"
                translate="Dialog.DeleteRequestOwnerInformation">
            </div>
            <closable-wrapper [title]="'Requests of ' + userName" [collapse]="false">
                <ul class="list-group p-2 m-1 overflow-auto" style="max-height: 300px;">
                    <ng-container *ngFor="let request of requests">
                        <li class="list-group-item d-block p-2">
                            <app-delete-user-request-list [request]="request"></app-delete-user-request-list>
                        </li>
                    </ng-container>
                </ul>
            </closable-wrapper>
        </ng-container>

        <ng-container *ngIf="!allowedToDeleteUser && hasRequests">
            <ng-container *ngIf="!isOfSameOrganisation">
                <div class="pt-3" translate="Dialog.CantDeleteUserInformation"></div>
            </ng-container>

            <ng-container *ngIf="deleteYourself">
                <div class="pt-3" translate="Dialog.CantDeleteYourselfInformation"></div>
            </ng-container>
        </ng-container>

        <div class="col-12 pt-5 pb-2 d-table w-100">
            <span class="float-start"><button type="button" class="btn btn-sm btn-outline-primary" (click)="closeWithoutDeleting()" translate="Button.Back"></button></span>
            <span class="float-end"><button type="button" class="btn btn-sm btn-danger" (click)="deleteUser()" translate="Button.DeleteUser" [disabled]="!allowedToDeleteUser"></button></span>
        </div>
    </div>
</div>